// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TicketOrderDetails from "./TicketOrderDetails.bs.js";
import * as TicketBasicDetailsCmp from "./TicketBasicDetailsCmp.bs.js";

function TicketLeftSection(Props) {
  var ticket = Props.ticket;
  return React.createElement("div", {
              className: "c-ticket-left-section"
            }, React.createElement(TicketOrderDetails.make, {
                  ticket: ticket
                }), React.createElement(TicketBasicDetailsCmp.make, {
                  ticket: ticket
                }));
}

var make = TicketLeftSection;

export {
  make ,
  
}
/* react Not a pure module */
